import { get } from 'lodash';
import { MyInfo } from './MyInfo.model';
import { StructureStatusEnum } from './../enum/structure-status.enum';
import { IDTypeEnum } from '../enum/id-type.enum';


export class Occupier {
  structure_status         : StructureStatusEnum | undefined;
  myinfo                   : MyInfo;
  dod?                     : string;
  own_property             : boolean | undefined;
  relationship_with_owner  : string;
  is_related               : boolean | undefined;
  spouse_id_type           : IDTypeEnum | undefined;
  spouse                   : string;
  id_type                  : IDTypeEnum | undefined;
   
  constructor(initial?: any) {
    this.structure_status          = get(initial, 'structure_status',        undefined);
    this.myinfo                    = get(initial, 'myinfo',                  new MyInfo(initial)); //Required initial for retrieve saveDraft mapping  used
    this.dod                       = get(initial, 'dod', "");
    this.own_property              = get(initial, 'own_property',            undefined);
    this.relationship_with_owner   = get(initial, 'relationship_with_owner', '');
    this.is_related                = get(initial, 'is_related',              undefined);
    this.spouse_id_type            = get(initial, 'spouse_id_type',  undefined);
    this.spouse                    = get(initial, 'spouse',  "");
    this.id_type                   = get(initial, 'id_type',  undefined);
  }

  
}
